import React from 'react';
import Infobae from '../../../assets/images/press/infobae.png';
import Bloom from '../../../assets/images/press/bloom.svg';
import Clarin from '../../../assets/images/press/clarin.svg';
import Coin from '../../../assets/images/press/coin.svg';
import Forbes from '../../../assets/images/press/forbes.svg';
import Nacion from '../../../assets/images/press/nacion.svg';
import Expansion from '../../../assets/images/press/expansion.png';
import MexicoBusiness from '../../../assets/images/press/mexicobusiness.png';
import MundoEjecutivo from '../../../assets/images/press/mundoejecutivo.png';
import RealEstate from '../../../assets/images/press/realestate.png';
import ElEconomista from '../../../assets/images/press/eleconomista.png';
import EnConcreto from '../../../assets/images/press/enconcreto.png';
import CioNoticias from '../../../assets/images/press/cionoticias.svg';
import { useCountry } from '../../../contexts/CountryContext';
import { Box, Copy } from '../../SimpleUI';
import SectionLayout from '../SectionLayout';

const Press = () => {
  const { countryPrefix } = useCountry();
  const pressLogos = {
    '/ar': [
      {
        icon: Infobae,
        alt: 'Infobae',
        url:
          'https://www.infobae.com/inhouse/2023/12/28/oportunidades-de-inversion-cual-es-la-plataforma-que-facilita-el-acceso-al-real-estate-con-bajos-montos-en-pesos/',
      },
      {
        icon: Nacion,
        alt: 'La Nación',
        url:
          '/simple-academy/crearon-una-plataforma-que-permite-invertir-en-proyectos-de-nordelta-con-10-000/578',
      },
      {
        icon: Clarin,
        alt: 'Clarín',
        url: '/simple-academy/empezar-de-cero-despues-de-los-40/531',
      },
      {
        icon: Coin,
        alt: 'Cointelegraph',
        url:
          '/simple-academy/la-tokenizacion-inmobiliaria-en-latam-sigue-en-expansion/565',
      },
      {
        icon: Forbes,
        alt: 'Forbes',
        url:
          'https://www.forbesargentina.com/innovacion/quieren-revolucionar-crowdfunding-inmobiliario-apoyandose-crypto-quienes-son-proponen-n21324',
      },
      {
        icon: Bloom,
        alt: 'Bloomberg en línea',
        url:
          '/simple-academy/radiografia-del-inversor-millennial-en-latinoamerica/550',
      },
    ],
    '/mx': [
      {
        icon: Expansion,
        alt: 'Expansion',
        url:
          'https://expansion.mx/finanzas-personales/2024/02/09/como-invertir-bienes-raices-con-poco-dinero',
      },
      {
        icon: MexicoBusiness,
        alt: 'Mexico Business',
        url:
          'https://mexicobusiness.news/finance/news/simplestate-expands-real-estate-investment-services-mexico',
      },
      {
        icon: MundoEjecutivo,
        alt: 'Mundo Ejecutivo',
        url:
          'https://mundoejecutivo.com.mx/mujer-ejecutiva/5-formas-en-que-la-inteligencia-artificial-esta-transformando-el-mercado-inmobiliario/',
      },
      {
        icon: RealEstate,
        alt: 'Real Estate',
        url:
          'https://www.realestatemarket.com.mx/noticias/mercado-inmobiliario/44953-transformando-el-mercado-inmobiliario-el-rol-crucial-de-la-ia',
      },
      {
        icon: ElEconomista,
        alt: 'El Economista',
        url:
          'https://www.eleconomista.com.mx/econohabitat/Simplestate-la-plataforma-promete-inversiones-inmobiliarias-desde-100-pesos-en-Estados-Unidos-20240208-0141.html',
      },
      {
        icon: EnConcreto,
        alt: 'En Concreto',
        url:
          'https://grupoenconcreto.com/noticias/educacion-financiera-para-incentivar-inversion-especialistas/',
      },
      {
        icon: CioNoticias,
        alt: 'Cio Noticias',
        url:
          'https://cionoticias.tv/2024/02/05/simplestate-llega-a-mexico-para-abrir-las-puertas-a-las-inversiones-inmobiliarias/',
      },
    ],
  };

  return (
    <SectionLayout paddingY="large" backgroundColor="white">
      <Box
        width="100%"
        maxWidth="1200px"
        paddingX="medium"
        margin="auto"
        marginY="xxxlarge"
      >
        <Box backgroundColor="primary" borderRadius="medium" padding="xlarge">
          <Box marginY="large">
            <Copy
              tag="h2"
              fontWeight="bold"
              color="_darkGray"
              fontSize="_newHomeTitle"
            >
              Algunas notas que hablan de Simplestate
            </Copy>
          </Box>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent={{
              mobile: 'space-between',
              desktop: 'space-evenly',
            }}
            alignItems="center"
          >
            {pressLogos[countryPrefix].map((press, i) => (
              <Box
                key={i}
                src={press.icon}
                tag="img"
                alt={press.alt}
                margin={{ mobile: 'medium', desktop: 'large' }}
                cursor="pointer"
                maxWidth={
                  countryPrefix === '/ar'
                    ? { mobile: i % 2 === 0 ? '30%' : '40%', desktop: 'auto' }
                    : press.alt === 'El Economista'
                    ? '35%'
                    : '30%'
                }
                onClick={() =>
                  press.url.startsWith('http')
                    ? window.open(press.url, '_blank')
                    : window.open(`${countryPrefix}${press.url}`, '_blank')
                }
              />
            ))}
          </Box>
        </Box>
      </Box>
    </SectionLayout>
  );
};

export { Press };
